import { Component, OnInit } from '@angular/core';
import { UserForResetPassword } from 'src/app/core/models/user-for-reset-password';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppToastService } from 'src/app/shared/services/app-toast.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss'],
  standalone: false,
})
export class ChangepasswordComponent implements OnInit {
  userEmail: string;
  code: string;
  user: UserForResetPassword;

  registerForm: UntypedFormGroup;
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private readonly toastService: AppToastService,
    private router: Router,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.createForm();

    this.activatedRoute.queryParams.subscribe((queryParams: any) => {
      this.userEmail = queryParams.userEmail;
      this.code = queryParams.code;
    });

    this.code = encodeURIComponent(this.code);
  }

  createForm() {
    this.registerForm = this.fb.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(30),
          ],
        ],
        confirmPassword: ['', [Validators.required]],
      },
      { validator: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(g: UntypedFormGroup) {
    return g.get('password').value === g.get('confirmPassword').value
      ? null
      : { mismatch: true };
  }

  changePassword() {
    if (this.registerForm.valid) {
      this.user = Object.assign({}, this.registerForm.value);
      this.user.email = this.userEmail;
      this.user.code = this.code;

      this.authService.resetPassword(this.user).subscribe({
        next: () => {
          this.router.navigate(['/login']);
          this.toastService.success('Success', 'Your password has been successfully changed. You can now log in.');
        },
        error: () => {},
      });
    }
  }
}
